<template>
  <footer>
    <div class="container w1320">
      <div class="flex">
        <div class="menu">
          <div class="item">
            <router-link class="title" to="/" tag="div">首页</router-link>
          </div>
          <div class="item">
            <router-link class="title" to="/productsType" tag="div">产品中心</router-link>
            <div class="links">
              <router-link :to="`/products/${item.ID}`" v-for="item in product" :key="item.ID">{{item.CALLED}}</router-link>
            </div>
          </div>
          <div class="item">
            <router-link class="title" to="/about" tag="div">博洋生活</router-link>
            <div class="links">
              <router-link to="/about">企业简介</router-link>
              <router-link to="/about">博洋生活</router-link>
            </div>
          </div>
          <div class="item">
            <router-link class="title" to="/news" tag="div">企业动态</router-link>
            <div class="links">
              <router-link to="/news">企业资讯</router-link>
            </div>
          </div>
          <div class="item">
            <router-link class="title" to="/agent" tag="div">授权代理</router-link>
            <div class="links">
              <router-link to="/agent">授权代理</router-link>
            </div>
          </div>
          <div class="item">
            <router-link class="title" to="/contact" tag="div">联系我们</router-link>
            <div class="links">
              <router-link to="/contact">联系我们</router-link>
            </div>
          </div>
        </div>
        <div class="contact">
          <div class="logo">
            <img src="@/assets/images/logo2.png" alt="">
          </div>
          <div class="tel"><i class="el-icon-phone-outline"></i>400-885-5208</div>
          <div class="qrcode">
            <div class="item">
              <img src="@/assets/images/qrcode2.png" alt="">
              <div>JD.COM</div>
            </div>
            <div class="item">
              <img src="@/assets/images/qrcode.png" alt="">
              <div>WeChat</div>
            </div>
          </div>
          <div class="links">
            <a href=""><i class="fa fa-linkedin"></i></a>
            <a href=""><i class="fa fa-facebook"></i></a>
            <a href=""><i class="fa fa-twitter"></i></a>
            <a href=""><i class="fa fa-instagram"></i></a>
            <a href=""><i class="fa fa-youtube-play"></i></a>
          </div>
        </div>
      </div>
      <div class="copyright">
        <p>
          <span>Copyright © 2019 宁波博洋纺织科技有限公司</span>
          <span>All Rights Reserved .</span>
          <span>网站建设：<a href="https://www.seniorweb.cn/">山久网络</a></span>
        </p>
        <a href="http://www.beian.miit.gov.cn/" target="_blank">浙ICP备19019247号-1</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data(){
    return{
      product:[]
    }
  },
  mounted(){
    this.getProductType()
  },
  methods: {
    getProductType(){
      this.$$axios.get('/php/productstype.php', {
        params: {
          tid: 63,
          num:5
        }
      })
      .then(res=>{
        this.product=res.data
      })
      .catch(error=>{
        console.log(error);
      });
    },
  }
}
</script>

<style scoped>
footer{
  background-color: #5e7987;
  color: #fff;
}
footer .container{
  position: relative;
  padding: 120px 0 40px;
}
footer .container .menu{
  flex: auto;
  display: flex;
  justify-content: space-between;
  font-weight: lighter;
}
footer .container .menu .item .title{
  font-size: 14px;
  cursor: pointer;
}
footer .container .menu .item .title::after{
  content: '';
  display: block;
  width: 30px;
  height: 1px;
  background-color: rgba(22,22,22,.2);
  margin: 10px auto 0;
}
footer .container .menu .item .links{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
footer .container .menu .item .links a{
  font-size: 12px;
  line-height: 35px;
  transition: .5s;
  color: #cbcbcb;
}
footer .container .menu .item .links a:hover{
  color: #314b59;
}
footer .container .contact{
  margin-left: 100px;
  text-align: right;
}
footer .container .contact .logo{
  display: none;
  margin-bottom: 20px;
}
footer .container .contact .tel{
  font-size: 23px;
}
footer .container .contact .qrcode{
  display: flex;
  justify-content: flex-end;
  text-align: center;
  font-size: 14px;
  line-height: 30px;
  font-weight: lighter;
  margin-top: 20px;
}
footer .container .contact .qrcode img{
  max-width: 70px;
}
footer .container .contact .qrcode .item+.item{
  margin-left: 40px;
}
footer .container .contact .links{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 20px;
}
footer .container .contact .links a+a{
  margin-left: 10px;
  font-size: 12px;
}
footer .copyright{
  text-align: right;
  font-size: 14px;
  line-height: 24px;
  font-weight: lighter;
}
footer .copyright span{
  display: inline-block;
}
footer .copyright a{
  transition: .5s;
}
footer .copyright a:hover{
  color: #314b59;
}
@media(max-width: 768px){
  footer .container{
    padding: 60px 20px;
  }
  footer .container .menu{
    display: none;
  }
  footer .container > .flex{
    justify-content: center;
  }
  footer .container .contact{
    margin-left: 0;
    text-align: center;
  }
  footer .container .contact .logo{
    display: block;
  }
  footer .container .contact .qrcode{
    justify-content: center;
  }
  footer .container .contact .links{
    display: none;
  }
  footer .copyright{
    text-align: center;
    margin-top: 30px;
    line-height: 38px;
  }
  footer .copyright span{
    display: block;
  }
  footer .copyright p:last-of-type{
    display: none;
  }
}
</style>
